namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustInDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        AdjFg?: number;
    }

    export namespace IcStockAdjustInDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockAdjustInDt';
        export const deletePermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const insertPermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const readPermission = '2Inventory:รายการ:ปรับปรุง:View';
        export const updatePermission = '2Inventory:รายการ:ปรับปรุง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            AdjFg = "AdjFg"
        }
    }
}
